import {NgModule} from "@angular/core";
import {VisualizeEngine} from "./visualize.engine";
import {VisualizeEngineImpl} from "./visualize.engine.impl";

@NgModule({
  providers: [
    {
      provide: VisualizeEngine,
      useClass: VisualizeEngineImpl
    },
  ],
  exports: []
})
export class VisualizeEngineModule {
}

export * from './visualize.engine';
export * from './types';